import React, {useState, useEffect} from 'react';
import { Box, Button } from '@mui/material';

import CasaAI from '../../shared/icons/CasaAI';
import DraggableChat from './components/DraggableChat';
import useDraggableChat from './hooks/useDraggableChat';
import {chatBridge} from "../../shared/helpers/draggable-chat-bridge";

const ChatButton: React.FC = () => {
  const [isChatOpen, setChatOpen] = useState<boolean>(false);
  const { isMinimized, setIsMinimized, view, setView, setSuggestionMessage, createSession, setActiveSession } = useDraggableChat();

  useEffect(() => {
      const handleBridgeOpen = (detail: any) => {
          setIsMinimized(false);
          setChatOpen(true);
          createSession();
          if (detail?.message) {
              setSuggestionMessage(detail.message);
          }
      };

      chatBridge.onOpen(handleBridgeOpen);

      return () => {
          window.removeEventListener('OPEN_GARGI_CHAT', handleBridgeOpen as EventListener);
      };
  }, [setIsMinimized, setChatOpen, createSession, setSuggestionMessage]);

  const handleToggleChat = (): void => {
      if(isMinimized) setIsMinimized(false)
      setChatOpen(true);
  };

  const handleCloseChat = (): void => {
    setChatOpen(false);
    setIsMinimized(false);
    if(view !== 'chat')  setView('chat');
    setActiveSession({id:"temp-session", name: "Untitled", createdAt: "", updatedAt: ""})
  };

  return (
    <Box sx={{ height: '40px', position: 'relative', width: 'auto' }}>
      <Button
        onClick={handleToggleChat}
        disableElevation
        disableRipple
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          backgroundColor: '#F8F5FF',
          border: '1px solid #E5D5FF',
          borderRadius: '30px',
          padding: '4px 16px 4px 6px',
          textTransform: 'none',
          minWidth: 'auto',
          height: '40px',
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: '#F1EBFF',
          },
        }}
      >
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '28px',
          height: '28px',
          borderRadius: '50%',
          background: '#FFFFFF',
          flexShrink: 0,
          '& > svg': {
            width: '24px',
            height: '24px',
          }
        }}>
          <CasaAI />
        </Box>
        <Box sx={{
          color: '#31119E',
          fontWeight: 700,
          fontSize: '15px',
          whiteSpace: 'nowrap'
        }}>
          Gargi AI
        </Box>
      </Button>
      <DraggableChat open={isChatOpen} onClose={handleCloseChat} />
    </Box>
  );
};

export default ChatButton;